import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { ITEMS, STRINGS } from "@/lib/i18n";

const LangContext = createContext(null);
const KEY = "hithayu_lang";

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem(KEY) || "en");

  useEffect(() => {
    localStorage.setItem(KEY, lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const value = useMemo(() => {
    const t = (key, vars = {}) => {
      const s = STRINGS[lang]?.[key] ?? STRINGS.en[key] ?? key;
      return typeof s === "string" ? s.replace(/\{(\w+)\}/g, (_, k) => vars[k] ?? "") : s;
    };
    // [title, desc, extra] for a catalog item in the current language.
    const item = (id, title, desc, extra) => {
      const tr = ITEMS[lang]?.[id];
      return tr ? [tr[0], tr[1], tr[2] ?? extra] : [title, desc, extra];
    };
    return { lang, setLang, t, item };
  }, [lang]);

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
